import { Link } from 'react-router-dom'
import { Lock } from 'lucide-react'
import { useFeature } from '@/hooks/use-feature'

const FEATURE_LABEL: Record<string, string> = {
  events:           'Manajemen Event',
  members:          'Manajemen Member',
  cheki_form:       'Cheki Form',
  cheki_analytics:  'Cheki Analitik',
  theme_preset:     'Tema Preset',
  custom_theme:     'Tema Visual',
  gallery:          'Galeri Komponen',
  custom_pages:     'Halaman Kustom',
  music:            'Musik',
  shop:             'Shop',
  media:            'Media Library',
}

interface FeatureGateProps {
  feature: string
  children: React.ReactNode
}

export function FeatureGate({ feature, children }: FeatureGateProps) {
  const { hasFeature, isLoading } = useFeature(feature)

  // Render children while loading to avoid flash
  if (isLoading || hasFeature) return <>{children}</>

  const label = FEATURE_LABEL[feature] ?? feature

  return (
    <div className="flex flex-1 flex-col items-center justify-center py-24 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-muted">
        <Lock className="h-6 w-6 text-muted-foreground" />
      </div>
      <h2 className="text-lg font-semibold">Fitur Tidak Tersedia</h2>
      <p className="mt-1 max-w-xs text-sm text-muted-foreground">
        <span className="font-medium">{label}</span> tidak termasuk dalam paket langganan Anda
        saat ini.
      </p>
      <Link
        to="/settings/subscription"
        className="mt-5 inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
      >
        Lihat Paket
      </Link>
    </div>
  )
}
